import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.withCredentials = true;

for(const prop in axios) {
  if (axios.hasOwnProperty(prop)) {
    cacheCheck[prop] = axios[prop];
  }
}

export default async function cacheCheck() {

  if ( !arguments.length ) {
    return;
  }

  const config = arguments[0]
  const { params, url } = config

  const cacheKey = `${url}?${Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`

  // Params based caching exceptions
  if (params.skipCache || params.source == 'User') {
    return await axios.apply(this, arguments); 
  }

  if ( localStorage.getItem(cacheKey) ) {
    const cache = JSON.parse(localStorage.getItem(cacheKey));
    return {data: cache}
  } else {
    const req = await axios.apply(this, arguments); 
    localStorage.setItem(cacheKey, JSON.stringify(req.data));
    return req;
  }

}